<template>
  <section 
    class="layout-pt-lg layout-pb-lg tw-relative tw-bg-cover tw-bg-center"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <div class="tw-absolute tw-inset-0"></div>
    <div class="container tw-z-10">
      
      <div class="tw-flex tw-flex-col md:tw-flex-row tw-justify-between">
        
        <div class="tw-w-full md:tw-w-1/2 md:tw-pr-8">
          <h2
            class="md:tw-mb-12 tw-text-white"
          >
            {{ vars.titleText }}
          </h2>
          
         
          <div v-if="buttons" class="tw-hidden md:tw-block">
            <nuxt-link
              v-for="(button, index) in buttons"
              :key="`takeaction-button-desktop-${index}`"
              :to="button.link"
              :class="`n-${button.type} tw-w-auto`"
            >{{ button.label }}</nuxt-link>
          </div>
        </div>
        
       
        <div class="tw-w-full md:tw-w-1/2 tw-mt-4 md:tw-mt-0">
          
          <h6
            class="tw-mb-6 md:tw-mb-12 tw-mt-2 tw-text-white"
            
          >
            {{ vars.secondaryTitleText }}
          </h6>
          
          
          <div v-if="descriptions" class="tw-space-y-3">
            <p
              v-for="({ description }, index) in descriptions"
              :key="`takeaction-description-${index}`"
              class="tw-leading-relaxed"
             style="color: #D2D2D2 !important"
            >
              {{ description }}
            </p>
          </div>
        </div>
      </div>
      
      
      <div v-if="buttons" class="tw-block md:tw-hidden tw-mt-6">
        <nuxt-link
          v-for="(button, index) in buttons"
          :key="`takeaction-button-mobile-${index}`"
          :to="button.link"
          :class="`n-${button.type} tw-w-auto`"
        >{{ button.label }}</nuxt-link>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'TakeAction',
  
  mixins: [ComponentMixin],
  
  computed: {
    descriptions(): Array<{ description: string }> {
      // @ts-ignore - groupedVariables is provided by ComponentMixin
      return this.groupedVariables?.descriptions || [];
    },
    buttons(): Array<{ link: string; type: string; label: string }> {
      // @ts-ignore - groupedVariables is provided by ComponentMixin
      return this.groupedVariables?.buttons || [];
    },
    cards() {
      return this.groupedVariables.cards;
    },
  },
});
</script>

